import { render, staticRenderFns } from "./Transcription.vue?vue&type=template&id=ae4ce010&"
import script from "./Transcription.vue?vue&type=script&lang=js&"
export * from "./Transcription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae4ce010')) {
      api.createRecord('ae4ce010', component.options)
    } else {
      api.reload('ae4ce010', component.options)
    }
    module.hot.accept("./Transcription.vue?vue&type=template&id=ae4ce010&", function () {
      api.rerender('ae4ce010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/SPFPlayer/lib/Transcription.vue"
export default component.exports